import React from 'react';
import InvoiceMilestonesTable from './InvoiceMilestonesTable';
import AdditionalServicesTable from './AdditionalServicesTable';
import OtherItemsTable from './OtherItemsTable';
import ProductsTable from './ProductsTable';
import ProjectExpenses from './ProjectExpenses';
import RevenueAdjustmentsLedger from './RevenueAdjustmentsLedger';
import RevenueRecognitionLedger from './RevenueRecognitionLedger';
import { HelpMessage } from '~/components';
import styled from 'styled-components';

const PreMessage = styled.div`
  white-space: pre-wrap;
  font-style: normal;
  word-break: break-word;
`;

export default function AccountingTab({
  project,
  formik,
  projectModel,
  onProjectExpensesChange,
  onProductItemsChange,
  onServiceItemsChange,
  onInvoiceMilestonesChange,
  onOtherItemsChange,
  onRevenueAdjustmentsChange,
  onRevenueRecognitionLedgerChange,
  onRefetch,
}) {
  return (
    <>
      {formik.values.accountingNotes && (
        <HelpMessage>
          <PreMessage>
            <strong>Accounting Notes:</strong>
            <br />
            {formik.values.accountingNotes}
          </PreMessage>
        </HelpMessage>
      )}

      {['fixed', 'fixed_recurring'].includes(projectModel.billingTypeId) && (
        <InvoiceMilestonesTable projectModel={projectModel} onChange={onInvoiceMilestonesChange} />
      )}

      {['fixed', 'fixed_recurring'].includes(projectModel.billingTypeId) &&
        ['manual', 'automated_hours', 'automated_tm_basis', 'automated_services_cost'].includes(
          projectModel.revenueRecognitionMethod,
        ) && (
          <RevenueRecognitionLedger
            project={project}
            formik={formik}
            projectModel={projectModel}
            onRefetch={onRefetch}
            onChange={onRevenueRecognitionLedgerChange}
          />
        )}

      <ProjectExpenses projectModel={projectModel} onChange={onProjectExpensesChange} />

      {['tm', 'fixed', 'fixed_recurring'].includes(projectModel.billingTypeId) && (
        <>
          <ProductsTable projectModel={projectModel} onChange={onProductItemsChange} />

          <AdditionalServicesTable projectModel={projectModel} onChange={onServiceItemsChange} />

          <OtherItemsTable projectModel={projectModel} onChange={onOtherItemsChange} />

          <RevenueAdjustmentsLedger projectModel={projectModel} onChange={onRevenueAdjustmentsChange} />
        </>
      )}
    </>
  );
}
